import { render, staticRenderFns } from "./TrademarkObjectionToUsCaseDecisionForm.vue?vue&type=template&id=03b8227c&"
import script from "./TrademarkObjectionToUsCaseDecisionForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkObjectionToUsCaseDecisionForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkObjectionToUsCaseDecisionForm.vue?vue&type=style&index=0&id=03b8227c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports